import APP_ROUTES from "../../Configurations/APP_ROUTES"

export type appMenuPageConstType = {
    header: string,
    navigateTo: string
}

export const appMenuPageConst: appMenuPageConstType[] = [
    {
        header: "Why SimplerHome",
        navigateTo: String(APP_ROUTES.WHY_SIMPLER_HOME.pathname),
    },
    {
        header: "Features",
        navigateTo: String(APP_ROUTES.FEATURE.pathname),
    },
    {
        header: "Home Maintenance Guide",
        navigateTo: String(APP_ROUTES.HOME_MAINTENANCE_GUIDE.pathname),
    },
    {
        header: "Contact",
        navigateTo: String(APP_ROUTES.CONTACT.pathname),
    },
    // {
    //     header: "Premium",
    //     navigateTo: String(APP_ROUTES.PREMIUM.pathname),
    // },
]


